import { docReady } from '../helpers/docReady';
import '../../styles/templates/cart.scss';
docReady(() => {
    // console.log('Cart Template JS Ready');
});
